<template>
  <div class="m-edition-section-content-info-submenu m-edition-section-content-info-submenu-asset">
    <ul>
      <li>
        <router-link
          :class="[$t('mEditionMenu.asset.signedStudents.subject') === $route.params.subject
            && ($t('mEditionMenu.asset.signedStudents.children.students.subedition') === $route.params.subedition
            || $t('mEditionMenu.asset.signedStudents.children.contents.subedition') === $route.params.subedition)
              ? 'submenu-item-active submenu-item-active-assets'
              : '']"
          :to="`/${$t('rPaths.asset')}/${this.$route.params.id}/${$t('mEditionMenu.asset.signedStudents.subject')}/${$t('mEditionMenu.asset.signedStudents.children.students.subedition')}`"
        >
          {{ $t('mEditionMenu.asset.signedStudents.children.students.subText') }}
        </router-link>
      </li>
      <li>
        <router-link
         :class="[$t('mEditionMenu.asset.signedStudents.subject') === $route.params.subject
            && $t('mEditionMenu.asset.signedStudents.children.invitations.subedition') === $route.params.subedition
              ? 'submenu-item-active submenu-item-active-assets'
              : '']"
          :to="`/${$t('rPaths.asset')}/${this.$route.params.id}/${$t('mEditionMenu.asset.signedStudents.subject')}/${$t('mEditionMenu.asset.signedStudents.children.invitations.subedition')}`"
        >
          {{ $t('mEditionMenu.asset.signedStudents.children.invitations.subText') }}
        </router-link>
      </li>
      <li>
        <router-link
         :class="[$t('mEditionMenu.asset.signedStudents.subject') === $route.params.subject
            && $t('mEditionMenu.asset.signedStudents.children.statics.subedition') === $route.params.subedition
              ? 'submenu-item-active submenu-item-active-assets'
              : '']"
          :to="`/${$t('rPaths.asset')}/${this.$route.params.id}/${$t('mEditionMenu.asset.signedStudents.subject')}/${$t('mEditionMenu.asset.signedStudents.children.statics.subedition')}`"
        >
          {{ $t('mEditionMenu.asset.signedStudents.children.statics.subText') }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetSignedStudentsSubMenu'
}

</script>
